/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileFile } from '../../models/profile-file';

export interface FilesByProfileId$Params {

/**
 * Profile id.
 */
  profileId: number;
}

export function filesByProfileId(http: HttpClient, rootUrl: string, params: FilesByProfileId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileFile>>> {
  const rb = new RequestBuilder(rootUrl, filesByProfileId.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileFile>>;
    })
  );
}

filesByProfileId.PATH = '/rest/profile/{profileId}/files';
